import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

export const usePreloaderFont = (data?: {
  font?: { main?: string; family_main?: string };
}) => {
  const [font, setFont] = useState<string>();

  const theme = useTheme() as {
    font?: {
      family_head?: string;
      family_main?: string;
      head: string;
      main: string;
    };
  };

  useEffect(() => {
    if (data?.font) {
      const baseSiteFont = `'${data.font.main || 'Inter'}',${data.font
        .family_main || 'sans-serif'}`;
      setFont(baseSiteFont);
      return;
    }
    if (theme?.font) {
      setFont(
        `'${theme?.font?.main || 'Inter'}',${theme?.font?.family_main ||
          'sans-serif'}`
      );
      return;
    }

    setFont(`'Inter',sans-serif`);
  }, [data, theme?.font]);

  return font!;
};
